module.exports = __webpack_public_path__ + "assets/945952fbe8a44a61778e7705a2edcfec.mp3";